<template>
    <li :class="classNames">
        <Link :href="$$route(routing)" v-if="routing">
            <svg-vue v-if="icon" :icon="icon" class="icon"/>
            <slot/>
        </Link>
        <span v-else>
            <svg-vue v-if="icon" :icon="icon" class="icon"/>
            <slot/>
        </span>
    </li>
</template>

<script>
export default {
    name: 'Step',
    props: [
        'classNames',
        'routing',
        'icon',
    ],
    computed: {

    }
};
</script>
